"use strict";
/**
 * A Shade share link, "https://app.shade.inc/publish/<share id>", opens
 * without a Shade account, so it is the one kind of Shade link a client may
 * see (NEW-3595) and the one Framework embeds for reviewing drafts
 * (NEW-3591). The backend's client filter (`linkForClient`) and the
 * frontend's embed read this one rule, so the two cannot disagree about
 * which links count.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHADE_APP_HOST = void 0;
exports.isShadeShareId = isShadeShareId;
exports.shadeShareLink = shadeShareLink;
exports.isShadeShareLink = isShadeShareLink;
exports.SHADE_APP_HOST = "app.shade.inc";
const SHARE_ID = /^[A-Za-z0-9_-]+$/;
const SHARE_PATH = /^\/publish\/[A-Za-z0-9_-]+\/?$/;
function isShadeShareId(value) {
    return SHARE_ID.test(value);
}
function shadeShareLink(shareId) {
    return `https://${exports.SHADE_APP_HOST}/publish/${encodeURIComponent(shareId)}`;
}
function isShadeShareLink(link) {
    let url;
    try {
        url = new URL(link.trim());
    }
    catch (_a) {
        return false;
    }
    return (url.protocol === "https:" &&
        url.hostname === exports.SHADE_APP_HOST &&
        SHARE_PATH.test(url.pathname));
}
